module.exports = __webpack_public_path__ + "static/media/logo.60729134.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/logo.png
// module id = 606
// module chunks = 23